import React from 'react';
import I18n from 'i18n-js';
import PacklinkModal from './packlink_modal';
import Window from '@reverbdotcom/commons/src/window_wrapper';
import { Paths } from './shared/url_helpers';

interface Props {
  orderId: string;
  classes?: string;
  translation?: string;
}

export const COMPONENT_NAME = 'PacklinkShippingLabelButton';
export const DEFAULT_CLASSES = 'button button--primary button--mini';
export const DEFAULT_TRANSLATION_KEY = 'discovery.packlink.getShippingLabel';

export function PacklinkShippingLabelButton({ orderId, classes, translation }: Props) {
  const [isOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  function onClick() {
    openModal();
  }

  function onDraftSuccess() {
    Window.open(Paths.packlinkRedirect.expand({}));
  }

  function getShippingLabelButton() {
    const classNames = classes || DEFAULT_CLASSES;
    const text = translation || I18n.t(DEFAULT_TRANSLATION_KEY);

    return (
      <button
        type="button"
        onClick={onClick}
        className={classNames}
      >
        {text}
      </button>
    );
  }

  return (
    <>
      {getShippingLabelButton()}
      <PacklinkModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        onDraftSuccess={onDraftSuccess}
        orderId={orderId}
      />
    </>
  );
}

export default PacklinkShippingLabelButton;
